  <div class="flex align-items-center justify-content-center min-h-screen">
    <div class="col-11 sm:col-8 md:col-6 lg:col-5 xl:col-4">
        <p-card styleClass="shadow-2">
            <ng-template pTemplate="header">
                <h2 class="text-center m-0 py-3 text-xl font-semibold text-700">Change Password</h2>
            </ng-template>
            
            <form [formGroup]="changePasswordForm" class="p-fluid">
                <div class="field">
                    <label for="oldPassword" class="text-600 mb-2 block">{{ "i18n.base.changePassword.oldPassword" | translate }}</label>
                    <p-password 
                        id="oldPassword" 
                        formControlName="oldPassword"
                        [toggleMask]="true"
                        [feedback]="false"
                        styleClass="w-full"
                        inputStyleClass="p-2"
                        [required]="true">
                    </p-password>
                    <app-error-messages [control]="oldPasswordControl"></app-error-messages>
                </div>

                <div class="field">
                    <label for="newPassword" class="text-600 mb-2 block">{{ "i18n.base.changePassword.newPassword" | translate }}</label>
                    <p-password 
                        id="newPassword" 
                        formControlName="newPassword"
                        [toggleMask]="true"
                        [required]="true"
                        inputStyleClass="p-2"
                        styleClass="w-full">
                    </p-password>
                    <app-error-messages [control]="newPasswordControl"></app-error-messages>
                </div>

                <div class="field">
                    <label for="newPasswordConfirm" class="text-600 mb-2 block">{{ "i18n.base.changePassword.newPasswordConfirm" | translate }}</label>
                    <p-password 
                        id="newPasswordConfirm" 
                        formControlName="newPasswordConfirm"
                        [toggleMask]="true"
                        [required]="true"
                        inputStyleClass="p-2"
                        styleClass="w-full">
                    </p-password>
                    <app-error-messages [control]="newPasswordConfirmControl"></app-error-messages>
                </div>

                <div class="mt-4">
                    <p-button 
                        [loading]="loading"
                        [disabled]="!changePasswordForm.valid"
                        (onClick)="changePassword()"
                        styleClass="w-full p-button-raised"
                        [label]="'i18n.base.changePassword.changePassword' | translate">
                    </p-button>
                </div>
            </form>
        </p-card>
    </div>
</div>